module.exports = __webpack_public_path__ + "static/img/5.914bb8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/20250903/szr/5.png
// module id = qSV6
// module chunks = 0